import React from "react"
import { useLocation } from "react-router-dom"
import { ResumoFornecedorContextProvider } from "./context/ResumoFornecedorContextProvider"
import { ResumoFornecedor } from "./ResumoFornecedor"

export function Index() {
    const location = useLocation()
    // Modo inicial (tela inicial): KPIs e gráficos usam sempre a última semana (últimos 7 dias).
    const modoInicial = new URLSearchParams(location.search).get("inicial") === "1"

    return (
        <ResumoFornecedorContextProvider modoInicial={modoInicial}>
            <ResumoFornecedor modoInicial={modoInicial} />
        </ResumoFornecedorContextProvider>
    )
}
